import React from 'react';
import { strings } from '../../../../localization';
import { RcAPI } from '../../../common/rcApi';
import ProgressOverlay from '../../../common/ProgressOverlay';
import PropTypes from 'prop-types';

export default class EnhancedVideoAccessDownload extends React.PureComponent {

    static propTypes = {
        stage: PropTypes.string.isRequired,
        ravenUuid: PropTypes.string.isRequired,
        //cameraType: PropTypes.string.isRequired,
        timestamp: PropTypes.number.isRequired,
        duration: PropTypes.number.isRequired,
        onCancel: PropTypes.func.isRequired, //dismissModalContainer
        onError: PropTypes.func.isRequired, 
        onSuccess: PropTypes.func.isRequired
    }

    constructor(props) {

        super(props);

        this.state = {
            roadRequestInProgress: false,
            cabinRequestInProgress: false
        }

    }

    onSend = (cameraType) => { // cameraType "ROAD" | "CABIN"
        console.log("this.props.stage", this.props.stage);

        const requestAsPromise = (cameraType) => {
            return new Promise((resolve, reject) => {
                RcAPI.refreshTempCredentials(this.props.stage)
                .then(
                    (apiJWT) => {
                        RcAPI.requestBasicCreateRavenMedia(
                            this.props.stage,
                            this.props.ravenUuid,
                            cameraType,
                            this.props.timestamp,
                            this.props.duration
                        )
                        .then(
                            (body) => {
                                return resolve(cameraType);
                            },
                            (error) => {
                                error.cameraType = cameraType;
                                return reject(error); // passed to .catch below
                            }
                        )
                        .catch( (error) => {
                            console.error("EnhancedVideoAccessDownload requestBasicCreateRavenMedia error.", error);
                            error.cameraType = cameraType;
                            return reject(error);
                        });
                    },
                    (error) => {
                        error.cameraType = cameraType;
                        return reject(error); // passed to .catch below
                    }
                )
                .catch( (error) => {
                    console.error("EnhancedVideoAccessDownload refreshTempCredentials error.", error);
                    error.cameraType = cameraType;
                    return reject(error);
                });    
            });
        }

        let promises = [];

        switch (cameraType) {
            case "ROAD":
                this.setState({
                    roadRequestInProgress: true,
                    cabinRequestInProgress: false,
                    bothRequestInProgress: false
                });
                promises.push(requestAsPromise(cameraType));
                break;
            case "CABIN":
                this.setState({
                    roadRequestInProgress: false,
                    cabinRequestInProgress: true,
                    bothRequestInProgress: false
                });
                promises.push(requestAsPromise(cameraType));
                break;
            case "BOTH":
                this.setState({
                    roadRequestInProgress: false,
                    cabinRequestInProgress: false,
                    bothRequestInProgress: true
                });
                promises.push(requestAsPromise("ROAD"));
                promises.push(requestAsPromise("CABIN"));
                break;
            default:
                console.error("EnhancedVideoAccessDownload onSend for unrecognized camera type.", cameraType);
                return;
        }

        Promise.all(promises)
        .then( (values) => {
            this.props.onSuccess();
        })
        .catch( (error) => {
            const cameraTypeForError = error.cameraType;
            this.props.onError(error.code, cameraTypeForError);
        });
    }

    render() {

        if (this.state.sendError) {
            return (
                <>
                    <div className="message">
                        {strings.settings_error_request_error}
                    </div>

                    <div className="actions">
                        <button onClick={this.props.onCancel} >{strings.app_ok}</button>
                    </div>
                </>
            );
        }

        if (this.state.sendSuccess) {
            return (
                <>
                    <div className="message">
                        {strings.settings_error_request_error}
                    </div>

                    <div className="actions">
                        <button onClick={this.props.onCancel} >{strings.app_ok}</button>
                    </div>
                </>
            );
        }

        // show initial prompt to send request:
        return (
            <>
                <div className="message">
                    {strings.eva_request_video_download_description}
                </div>

                <div className="actions eva-download-request">
                    <div style={{position:"relative"}/* to position ProgressOverlay "relative" to this button wrapper */}>
                        <button disabled={this.state.roadRequestInProgress || this.state.cabinRequestInProgress || this.state.bothRequestInProgress} onClick={ () => {this.onSend("ROAD")}} >
                            {strings.eva_road_camera}
                            {this.state.roadRequestInProgress ? <ProgressOverlay /> : null }
                        </button>
                    </div>

                    <div style={{position:"relative"}/* to position ProgressOverlay "relative" to this button wrapper */}>
                        <button disabled={this.state.cabinRequestInProgress || this.state.roadRequestInProgress || this.state.bothRequestInProgress} onClick={ () => {this.onSend("CABIN")}} >
                            {strings.eva_cabin_camera}
                            {this.state.cabinRequestInProgress ? <ProgressOverlay /> : null }
                        </button>
                    </div>

                    <div style={{position:"relative"}/* to position ProgressOverlay "relative" to this button wrapper */}>
                        <button disabled={this.state.roadRequestInProgress || this.state.cabinRequestInProgress || this.state.bothRequestInProgress} onClick={ () => {this.onSend("BOTH")}} >
                            {strings.eva_both_cameras}
                            {this.state.bothRequestInProgress ? <ProgressOverlay /> : null }
                        </button>
                    </div>

                </div>
            </>
        );
    }

}
